import IconButton from "@mui/material/IconButton";
import { Box } from "@mui/material";

function TrashIcon({ onClick }) {
  return (
    <Box>
      <IconButton sx={{ padding: "0px" }} onClick={onClick}>
        <Box
          sx={{
            background: "#EA4335",
            width: "11px",
            height: "12px",
            display: "inline-block",
            margin: "0 auto",
            position: "relative",
            borderBottomRightRadius: "2px",
            borderBottomLeftRadius: "2px",

            "& span": {
              position: "absolute",
              height: "2px",
              background: "#EA4335",
              top: "-4px",
              left: "-2px",
              right: "-2px",
              borderTopLeftRadius: "2px",
              borderTopRightRadius: "2px",
              transform: "rotate(0deg)",
              transition: "transform 250ms",
              transformOrigin: "19% 100%",
            },
            "& i": {
              position: "relative",
              width: "1px",
              height: "8px",
              background: "#ffffff",
              display: "block",
              margin: "2px auto",
              borderRadius: "1px",
              "&:after": {
                content: '""',
                width: "1px",
                height: "8px",
                background: "#ffffff",
                position: "absolute",
                left: "-3px",
                borderRadius: "1px",
              },
              "&:before": {
                content: '""',
                width: "1px",
                height: "8px",
                background: "#ffffff",
                position: "absolute",
                right: "-3px",
                borderRadius: "1px",
              },
            },
            "&:hover span": {
              transform: "rotate(-45deg)",
              transition: "transform 250ms",
            },
          }}
        >
          <span />
          <i />
        </Box>
      </IconButton>
    </Box>
  );
}

export default TrashIcon;
